/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';
import { IDescriptorBody } from '../../../descriptor';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IStringObjectPacketDataMessage extends IPackageDataMessage {
	data: string;
	data1?: string;
}

export default class StringObjectPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.STRING, MessageDataTypes.OBJECT ) )();

	public static readonly DESCRIPTOR_NAME: string = 'StringObjectPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'string',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: string, public readonly data1: Record<string, unknown> ) {
		super();
	}

	public toJSON(): IStringObjectPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1 ? JSON.stringify( this.data1 ) : undefined
		};
	}

	public static fromJSON( data: IStringObjectPacketDataMessage ): StringObjectPacketDataMessage {
		return new StringObjectPacketDataMessage( data.data, data.data1 && JSON.parse( data.data1 ) );
	}

	public static create( data: string, data1: Record<string, unknown> ): StringObjectPacketDataMessage {
		return new StringObjectPacketDataMessage( data, data1 );
	}
}
